import type { BundleCopy } from "@intelligems/ig-types/dtos/components";
import Stack from "@mui/material/Stack";

import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";

export const CopySection = ({
  copy,
  errors,
  onChange,
}: {
  copy: BundleCopy;
  errors?: Record<string, string>;
  onChange: (copy: BundleCopy) => void;
}) => (
  <Stack spacing={5}>
    <Panel.Header>Copy</Panel.Header>
    <Panel.TextField
      label="Heading"
      value={copy.heading}
      error={Boolean(errors?.["copy.heading"])}
      onChange={(e) => onChange({ ...copy, heading: e.target.value })}
    />
    <Panel.TextField
      label="Subheading"
      placeholder="Optional"
      value={copy.subheading ?? ""}
      onChange={(e) =>
        onChange({ ...copy, subheading: e.target.value || undefined })
      }
    />
    <Panel.TextField
      label="Button text"
      value={copy.buttonText}
      error={Boolean(errors?.["copy.buttonText"])}
      onChange={(e) => onChange({ ...copy, buttonText: e.target.value })}
    />
  </Stack>
);
